import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  to, 
  href, 
  variant = 'primary', 
  className = '', 
  onClick,
  ...props 
}) => {
  const baseClasses = 'px-4 py-2 rounded-md transition duration-300';
  
  const variantClasses = {
    primary: 'bg-primary text-white hover:bg-blue-800 btn-primary',
    secondary: 'bg-yellow-500 text-gray-900 font-bold hover:bg-yellow-400 btn-secondary',
    outline: 'bg-transparent border-2 border-white text-white hover:bg-white/10',
    link: 'text-gray-700 hover:text-primary'
  };
  
  const buttonClasses = `${baseClasses} ${variantClasses[variant]} ${className}`;
  
  // If 'to' prop is provided, render a Link from react-router-dom
  if (to) {
    return (
      <Link to={to} className={buttonClasses} {...props}>
        {children}
      </Link>
    );
  }
  
  // If 'href' prop is provided, render a regular anchor tag
  if (href) {
    return (
      <a href={href} className={buttonClasses} {...props}>
        {children}
      </a>
    );
  }
  
  // Otherwise, render a button element
  return (
    <button className={buttonClasses} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

export default Button;
